// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rh-2";
export var chatLink = "_rh-0";
export var chatText = "_rh-1";